export * from './actions/block.actions';
export * from './actions/connext.actions';
export * from './actions/real-time.actions';
export * from './actions/system.actions';
export * from './effects/system-life.effects';
export * from './effects/system-metadata.effects';
export * from './effects/system-subscription.effects';
export * from './effects/totalizer.effects';
export * from './effects/flow-chart.effects';
export * from './effects/real-time-telemetry.effects';
export * from './helpers/system';
export * from './selectors/system.selectors';
export * from './selectors/alerts-counter.selectors';
export * from './selectors/real-time.selectors';
export * from './selectors/evcharge-telemetry.selectors';
export * from './selectors/evcharge-energy-aggregation.selectors';
export * from './state/block.state';
export * from './state/system.state';

import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import { FlowChartEffects } from './effects/flow-chart.effects';
import { SystemLifeEffects } from './effects/system-life.effects';
import { SystemMetadataEffects } from './effects/system-metadata.effects';
import { SystemSubscriptionEffects } from './effects/system-subscription.effects';
import { TotalizerEffects } from './effects/totalizer.effects';
import { blockReducer } from './reducers/block.reducer';
import { systemReducer } from './reducers/system.reducer';
import { BlockState } from './state/block.state';
import { SystemsState } from './state/system.state';
import { MonthlyYearlyEnergyEffects } from './effects/monthly-yearly-energy.effects';
import { EnergyDataOverviewEffects } from './effects/energy-data-overview.effect';
import { DailyStateOverviewEffects } from './effects/daily-state-overview.effects';
import { AlertsListEffects } from './effects/alerts-list.effects';
import { DeviceDetailEffects } from './effects/device-detail.effects';
import { TelemetryReportEffects } from './effects/telemetry-report.effects';
import { DeviceListEffects } from './effects/device-list.effect';
import { AlertsCounterEffects } from './effects/alerts-counter.effects';
import { DeviceDailyPowersEffects } from './effects/device-daily-powers.effects';
import { PlantCardEffects } from './effects/plant-card.effects';
import { EventsListEffects } from './effects/events-list.effects';
import { EvchargeTelemetryEffects } from './effects/evcharge-telemetry.effects';
import { EvchargeEnergyAggregationEffects } from './effects/evcharge-energy-aggregation.effects';
import { HeatpumpEffects } from './effects/heatpump.effects';
import { RealTimeTelemetryEffects } from './effects/real-time-telemetry.effects';

export interface AppState {
  systemState: SystemsState;
  blockState: BlockState;
}

export const reducers: ActionReducerMap<AppState> = {
  systemState: systemReducer,
  blockState: blockReducer,
};

export const effects = [
  AlertsCounterEffects,
  AlertsListEffects,
  DailyStateOverviewEffects,
  DeviceDailyPowersEffects,
  DeviceDetailEffects,
  DeviceListEffects,
  EnergyDataOverviewEffects,
  EvchargeEnergyAggregationEffects,
  EvchargeTelemetryEffects,
  EventsListEffects,
  FlowChartEffects,
  HeatpumpEffects,
  MonthlyYearlyEnergyEffects,
  PlantCardEffects,
  RealTimeTelemetryEffects,
  SystemLifeEffects,
  SystemMetadataEffects,
  SystemSubscriptionEffects,
  TelemetryReportEffects,
  TotalizerEffects,
];

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    const nextState = reducer(state, action);
    const systemId = (action as any).systemId;
    const comment = (action as any).comment;

    let title = systemId ? `Action: ${action.type} - ${systemId}` : `Action: ${action.type}`;
    title = comment ? `${title} - ${comment}` : title;

    const timestamp = (new Date()).getTime();
    const hourMinuteSecondMillisecond = new Date(timestamp).toISOString().slice(11, 23);

    console.groupCollapsed(`%c${hourMinuteSecondMillisecond} %c${title}`, 'color: #fff; font-weight: bold', 'color: #13A4B8; font-weight: normal');
    console.log('Previous State:', state);
    console.log('Action:', action);
    console.log('Next State:', nextState);
    console.groupEnd();

    return nextState;
  };
}

export const metaReducers: MetaReducer<any>[] = [];
